import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, flatMap, catchError } from 'rxjs/operators';
import { combineEpics } from 'web-app/util/redux-observable';
import ChildApi from 'signin-app/api/child-api';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { getRestClientErrorMessage } from 'signin-app/api/clients/get-rest-client-error-message';
import { defaultErrorDuration, defaultSuccessDuration } from 'web-app/react/global-event/helpers/constants';
import translate from 'signin-app/helpers/translate';
import { childName as getChildName } from 'signin-app/child/selectors';
import * as Actions from './actions';
const checkOutChild = (action$, state$) => action$.pipe(ofType(Actions.checkOutChild.type), mergeMap(({ payload }) => {
    const { childId, pin, kcData } = payload;
    return ChildApi.checkOut(childId, pin, kcData).pipe(flatMap(response => {
        const state = state$.value;
        const childName = getChildName(state, { id: childId, childId });
        dispatchStatusMessageEvent({
            message: translate('signOutSuccess', { personName: childName }),
            statusType: 'Success',
            sticky: false,
            e2eId: '',
            duration: defaultSuccessDuration,
        });
        return [Actions.checkOutChildSuccess.action(response)];
    }), catchError(e => {
        dispatchStatusMessageEvent({
            message: getRestClientErrorMessage(e),
            statusType: 'Error',
            sticky: false,
            e2eId: '',
            duration: defaultErrorDuration,
        });
        return of(Actions.checkOutChildFailed.action(e));
    }));
}));
export default combineEpics(checkOutChild);
